// extracted by mini-css-extract-plugin
export default {"toastContainer":"Toast_toastContainer__YCGUm","show":"Toast_show__kKGii","fontUpdate":"Toast_fontUpdate__XatDx"};